// import 'Styles/themes/_wiski-critical.scss';

// // TODO remove for prod
// import 'Styles/styles.scss';

// // This import will add Promise to the window.
// import "promiscuous/promiscuous-browser-full";

// // Formulate customizations.
// import "../components/formulate/brite-verify-validation";

// // Formulate plain JavaScript frontend.
// import "../../responsive.plain-javascript/plain-index";

// import "../lib/polyfills";

import { each } from '../lib/util';

// import HeaderComponent from '../header/header';
// import FooterComponent from '../footer/footer';
// import GraphicalCalloutCarousel from './widgets/graphical-callout-carousel/graphical-callout-carousel.widget';
// import GraphicalCalloutGrid from './widgets/graphical-callout-grid/graphical-callout-grid.widget';
// import AccordionComponent from './components/accordion';
// import ModalComponent from './components/modal/modal';
// import AttractionGallery from './widgets/attraction-gallery/attraction-gallery.widget';
// import CompoundCalloutList from './widgets/compound-callout-list/compound-callout-list.widget';
// import ChatComponent from './components/chat/chat';
// import DirectoryComponent from './widgets/directory/directory.widget';
// import StoreDetailsComponent from './widgets/store-details/store-details.widget';
// import BgComponent from './components/bg-img/bg-img';
// import ValidationComponent from './forms/validation';
// import Hero from './widgets/hero/hero.widget';
// import GraphicalBanner from './widgets/graphical-banner/graphical-banner.widget';
import Events from '../widgets/events/events.widget';
// import '../services/animations';

// list of components that will fire conditionally depending on whether
// the static selector property on them matches any dom elements
const components = [
    Events
];

// if(typeof DEVELOPMENT !== 'undefined' && DEVELOPMENT) {
//     window.cssLoaded = true;
// }

$(document).ready(function(){
    initEvents();
});
//bootstrap
// if (window.cssLoaded) {
//     init();
// } else {
//     window.appInit = function(){
//         setTimeout(() => {
//             init();
//         }, 0);
//     };
// }

function initEvents() {
    // let apiMap = {};
    // var touchsupport = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)
    // if (touchsupport){ // browser doesn't support touch
    //     document.documentElement.classList.add('js-touch');
    // }

    components.forEach((cmp) => {
        initEventsComponent(cmp);
    });

    // Components that require other components to funciton
    // const bgCmps = BgComponent.getEntryElements();
    // each(bgCmps, (cmp) => {
    //     new BgComponent(cmp, document.querySelector('.graphical-callout-grid'),
    //                         document.querySelector('.ww-graphical-callout-carousel'))
    // })
}

function initEventsComponent(cmp) {
    let cmpsOnPage = cmp.getEntryElements();
    if(cmpsOnPage.length) {
        each(cmpsOnPage, (el) => {
            new cmp(el);
        });
    }else{
        return false;
    }
}